import React, { useEffect, useState } from 'react'
import './claim-submission.css';
import { Button, message, Modal, Spin, Steps } from 'antd';
import PatientInformation from './containers/patient-information';
import { ClaimContext } from './component/claim-context';
import SupportingInformation from './containers/supporting-information/supporting-information';
import ReimbursementMethod from './containers/reimbursement-method/reimbursement-method';
import ClaimConfirmation from './containers/claim-confirmation/claim-confirmation';
import { useSelector } from 'react-redux';
import InputDrug from './containers/input-drug';
import { useParams } from 'react-router-dom';
import { usePrompt } from '../../../exports/usePrompt';
import LilyButton from '../../../components/button/lily-button';
import moment from 'moment';
import { parseDob } from '../../../exports/util';
import { formatStateCode } from '../../../exports/states-list';
import portalAPI from '../../../api/api';
import { GET_CLAIM_DETAIL_URL } from '../../../api/URLs';

const ClaimSubmissionPage = () => {
    const { caseNumber } = useParams();
    const [stage, setStage] = useState('drug');
    const user = useSelector((state) => state.authenticatedUser);
    const [current, setCurrent] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [entityClaim, setEntityClaim] = useState(null);
    const [supportingCurrent, setSupportingCurrent] = useState('');
    const [patientCurrent, setPatientCurrent] = useState(0);

    const fetchClaimDetail = async (caseNumber) => {
        setIsLoading(true);
        try {
            let URL = GET_CLAIM_DETAIL_URL.replace(":id", caseNumber);
            let rsp = await portalAPI.get(URL);
            if (rsp.data.status === 200) {
                setEntityClaim(rsp.data.data);
            }
        } catch (error) {
            message.error(`Failed to fetch claim detail.`);
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (!caseNumber) return;
        fetchClaimDetail(caseNumber);
    }, [caseNumber])

    const [tempClaimForm, setTempClaimForm] = useState({})
    const [linkedAccount, setLinkedAccount] = useState([]);
    const [claimForm, setClaimForm] = useState({
        copayCardInfo: {
            programId: '',
            programName: '',
            cardGroup: '',
            memberId: '',
        },
        insuranceCard: {
            rxBin: '',
            rxGroup: '',
            rxPcn: '',
        },
        insuranceInfo: {
            haveHealthInsurance: '',
            prescriptionBenefits: '',
            commercialHealthInsurance: '',
            insuranceCovered: '',
            copayAmount: null,
            prescriptionFilled: '',
        },
        proofOfPayment: [],
        eob: [],
        insuranceCards: [],
        signature: {
            signatureLink: '',
            signedAt: null,
        },
        paymentInfo: {
            option: '',
            method: '',
            directDeposit: null,
            checkByMail: {
                option: '',
                recipientName: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
            }
        },
        comments: '',
        amountRequested: 0,
    });
    const [achTnc, setAchTnc] = React.useState(false);

    const [supportOptions, setSupportOptions] = useState([
        {
            label: "Copay Card Member ID#",
            value: "saving-card",
            checked: false,
        },
        {
            label: "Original Pharmacy Receipt",
            value: "pharmacy-receipt",
            checked: false,
        },
        {
            label: "Explanation of Benefits",
            value: "eob",
            checked: false,
        },
        {
            label: "Primary Insurance Card",
            value: "insurance-card",
            checked: false,
        }
    ]);
    const [isBlocking, setIsBlocking] = useState(true);

    const [pdfFormData, setPdfFormData] = useState({
        "First Name": "",
        "Last Name": "",
        "MM": "",
        "DD": "",
        "YYYY": "",
        "Street 1": "",
        "Street 2": "",
        "City": "",
        "State": "",
        "Zip": "",
        "Email": "",
        "Date": "",
        "Unit": "",
        "+ 4": "",
        "Phone": "",
        "Drug Name": "",
        "Copay Amount": "",
        "Check Box11": "",
        "Check Box12": "",
        "Check Box13": "",
        "prescription_benefit": "",
        "Check Box14": "",
        "Check Box15": "",
        "Check Box16": "",
        "Check Box17": "",
        "Check Box18": "",
        "Signature19_es_:signer:signature": "",
        "Rx Group": "",
        "Rx ID2": "",
    });

    useEffect(() => {
        if (!user) return;
        let MM = "";
        let DD = "";
        let YYYY = "";

        const dob = user?.dob || null;
        if (dob) {
            const parsed = parseDob(dob);
            MM = parsed.format('MM');
            DD = parsed.format('DD');
            YYYY = parsed.format('YYYY');
        }

        setPdfFormData((prev) => ({
            ...prev,
            "First Name": user.firstName || '',
            "Last Name": user.lastName || '',
            "MM": MM,
            "DD": DD,
            "YYYY": YYYY,
            "Street 1": user?.address?.line1 || '',
            "Street 2": user?.address?.line2 || '',
            "City": user?.address?.city || '',
            "State": formatStateCode(user?.address?.state),
            "Zip": user?.address?.zip || '',
            "Email": user?.email || '',
            "Drug Name": claimForm?.copayCardInfo?.programName || '',
            "Phone": `${user?.phone?.number || ''}`,
            "Rx Group": user?.insuranceCard?.rxGroup || '',
            "Rx ID2": user?.copayCardInfo?.memberId || '',
            "Check Box11": true,
            "Check Box12": claimForm?.insuranceInfo?.haveHealthInsurance === "no" && true || "",
            "Check Box13": claimForm?.insuranceInfo?.haveHealthInsurance === "yes" && true || "",
            "prescription_benefit": claimForm?.insuranceInfo?.prescriptionBenefits || "",
            "Check Box14": claimForm?.insuranceInfo?.insuranceCovered === "The entire prescription" && true || "",
            "Check Box15": claimForm?.insuranceInfo?.insuranceCovered === "None of this prescription" && true || "",
            "Check Box16": claimForm?.insuranceInfo?.insuranceCovered === "All except copay" && true || "",
            "Copay Amount": `${claimForm?.insuranceInfo?.copayAmount || 0}`,
            "Check Box17": claimForm?.insuranceInfo?.prescriptionFilled === "A retail pharmacy store" && true || "",
            "Check Box18": claimForm?.insuranceInfo?.prescriptionFilled === "Through mail order or specialty pharmacy" && true || "",
        }));
    }, [user, claimForm]);

    useEffect(() => {
        if (!entityClaim) return;
        let data = {
            ...claimForm,
            copayCardInfo: entityClaim.copayCardInfo,
            insuranceCard: entityClaim.insuranceCard,
            insuranceInfo: entityClaim.insuranceInfo,
            proofOfPayment: entityClaim.proofOfPayment || [],
            eob: entityClaim.eob || [],
            insuranceCards: entityClaim.insuranceCards || [],
            paymentInfo: entityClaim.paymentInfo,
            comments: entityClaim.comments,
        }
        setTempClaimForm(data);
        setClaimForm(data);
        setSupportOptions((prev) => [
            ...prev.map((item) => {
                let checked = true;
                if (item.value === 'pharmacy-receipt') {
                    checked = entityClaim?.proofOfPayment?.length < 1 ? false : true
                }
                if (item.value === 'eob') {
                    checked = entityClaim?.eob.length < 1 ? false : true
                }
                if (item.value === 'insurance-card') {
                    checked = entityClaim?.insuranceCards.length < 2 ? false : true
                }
                return {
                    ...item,
                    checked: checked
                }
            })
        ]);
    }, [entityClaim])

    useEffect(() => {
        setClaimForm((prev) => ({
            ...prev,
            copayCardInfo: {
                programId: user?.copayCardInfo?.programId || '',
                programName: user?.copayCardInfo?.programName || '',
                cardGroup: user?.copayCardInfo?.cardGroup || '',
                memberId: user?.copayCardInfo?.memberId || '',
            },
            insuranceCard: {
                rxBin: user?.insuranceCard?.rxBin || '',
                rxGroup: user?.insuranceCard?.rxGroup || '',
                rxPcn: user?.insuranceCard?.rxPcn || '',
            },
        }))
        let entityAccounts = user?.reimbursementMethods.filter((item) => item.method === "direct-deposit");
        let newEntityAccounts = entityAccounts.map((item) => item.directDeposit);
        setLinkedAccount(newEntityAccounts);
    }, [user]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ''; // Required for modern browsers to trigger the confirmation dialog
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const [showModal, setShowModal] = useState(false);
    const [nextAction, setNextAction] = useState(null);

    usePrompt(isBlocking, (args, retry) => {
        setNextAction(() => retry);
        setShowModal(true);
    });

    const handleOk = () => {
        setShowModal(false);
        nextAction?.();
    };

    const handleCancel = () => {
        setShowModal(false);
        setNextAction(null);
    };

    const steps = [
        {
            title: 'Patient Information',
            content: 'saving-card',
            element: []
        },
        {
            title: 'Supporting Information',
            content: 'patient-information',
            element: []
        },
        {
            title: 'Reimbursement Method',
            content: 'insurance-information',
            element: []
        },
        {
            title: 'Confirmation',
            content: 'insurance-information',
            element: []
        },
    ];

    const items = steps.map(item => ({ key: item.title, title: item.title }));

    let contextProps = {
        setCurrent: setCurrent,
        claimForm: claimForm,
        setClaimForm: setClaimForm,
        supportOptions: supportOptions,
        setSupportOptions: setSupportOptions,
        setIsBlocking: setIsBlocking,
        pdfFormData: pdfFormData,
        setPdfFormData: setPdfFormData,
        supportingCurrent: supportingCurrent,
        setSupportingCurrent: setSupportingCurrent,
        patientCurrent: patientCurrent,
        setPatientCurrent: setPatientCurrent,
        linkedAccount: linkedAccount,
        setLinkedAccount: setLinkedAccount,
        achTnc: achTnc,
        setAchTnc: setAchTnc,
    }

    return (
        // <Spin spinning={isLoading}>
        <ClaimContext.Provider value={contextProps}>
            <div className='claim-layout'>
                {
                    stage === 'drug' && (
                        <InputDrug setStage={setStage} />
                    ) || (
                        <div className='claim-submission-layout'>
                            <div className='row'>
                                <div className='col-md-4 col-12'>
                                    <div className='' style={{ height: '300px' }}>
                                        {
                                            current < steps.length && (
                                                <Steps
                                                    className='steps-layout h-100'
                                                    current={current}
                                                    items={items}
                                                    direction="vertical"
                                                />
                                            )
                                        }
                                    </div>
                                </div>
                                <div className='col-md-8 col-12'>
                                    <div>
                                        {(() => {
                                            switch (current) {
                                                case 0:
                                                    return <PatientInformation setStage={setStage} />
                                                case 1:
                                                    return <SupportingInformation />
                                                case 2:
                                                    return <ReimbursementMethod />
                                                case 3:
                                                    return <ClaimConfirmation tempClaimForm={tempClaimForm} caseNumber={caseNumber} />
                                                default:
                                                    return
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

            <Modal
                title="Are you sure you want to leave?"
                open={showModal}
                onCancel={handleCancel}
                footer={
                    <div className='d-flex flex-row justify-content-end gap-2'>
                        <Button onClick={handleOk} >Stay</Button>
                        <LilyButton text="Leave" style={{ borderRadius: '5px' }} onClick={handleOk} />
                    </div>
                }
            >
                <p>You have unsaved changes. Are you sure you want to leave?</p>
            </Modal>
        </ClaimContext.Provider>
        // </Spin>
    )
}

export default ClaimSubmissionPage